import AnalyticsDashboardAppConfig from './analytics/AnalyticsDashboardAppConfig';
import ProjectDashboardAppConfig from './project/ProjectDashboardAppConfig';

const dashboardsConfigs = [AnalyticsDashboardAppConfig, ProjectDashboardAppConfig];

export default dashboardsConfigs;
